import {DLSelectClearIndicator} from '@wallaby-ui/core';
import * as React from 'react';

import FilterNodeRemoveButton from './FilterNodeRemoveButton';

const noop = () => {};

const FilterNodeSelectRemoveAll = (props) => (
  <DLSelectClearIndicator {...props}>
    <FilterNodeRemoveButton removeFilter={noop} />
  </DLSelectClearIndicator>
);

export default FilterNodeSelectRemoveAll;
